import {
  ENDPOINT_ASSINATURA_TERMO_ENTREGA_DE_CHAVES,
  ENDPOINT_CHECKLIST,
  ENDPOINT_DOWNLOAD_DOCUMENTS_VA_EC,
  ENDPOINT_VISTORIA_LOGIN
} from "utils/constants";
import { axiosInstance } from "../servicesSetup";

export const postSignTerm = async dataR => {
  const instance = await axiosInstance();
  const { data } = await instance.post(
    ENDPOINT_ASSINATURA_TERMO_ENTREGA_DE_CHAVES,
    dataR,
    {
      responseType: "blob"
    }
  );
  return data;
};

export const postEcLogin = async (cpf, email) => {
  const instance = await axiosInstance();
  return instance.post(
    ENDPOINT_VISTORIA_LOGIN,
    {
      cpf,
      email
    },
    {
      params: {
        tipo: "EC"
      }
    }
  );
};

export const getOcorrenciaCRM = async idUnidade => {
  const instance = await axiosInstance();
  return instance.get(ENDPOINT_CHECKLIST, {
    params: {
      idUnidade,
      apenasNumeroOcorrencia: true
    }
  });
};

export const downloadDocumentNew = async idUnidade => {
  const instance = await axiosInstance();
  const { data } = await instance.get(ENDPOINT_DOWNLOAD_DOCUMENTS_VA_EC, {
    params: {
      unidadeId: idUnidade,
      tipo: "EC"
    },
    responseType: "blob"
  });
  return data;
};
